/** @format */

import { Box } from '@mui/material';
import LoginForm from '../features/login/components/loginForm';

function Login() {
  return (
    <Box className='login__container'>
      <LoginForm />
    </Box>
  );
}

export default Login;
